import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { TramiteProvider } from './context/TramiteContext';
import { ThemeProvider } from './context/ThemeContext';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <ThemeProvider>
        <AuthProvider>
            <TramiteProvider>
                <App />
            </TramiteProvider>
        </AuthProvider>
    </ThemeProvider>
);
